<template>
    <div>
        <limitless-page-header
            title="Kortbeställning"
            :sub-title="'E-kort - Ordernummer: ' + this.id"
            :title-template="'E-kort - Kortbeställning #' + this.id"
        ></limitless-page-header>

        <div class="content">
            <tb-skeleton v-if="busy_loading" :height="100" :theme="'opacity'" :shape="'radius'" bg-color="#dcdbdc"></tb-skeleton>
            <div v-else-if="!busy_loading && settings">
                <ValidationObserver ref="settingsform">
                    <form @submit="saveTemplateSettings">
                        <div v-if="settings.use_view">
                            <!-- Use new templates -->
                            <template-editor
                                v-model="settings.view"
                                :customer-id="settings.customer_id"
                                :card-order-id="settings.card_order_id"
                                mode="normal"
                            >
                                <div class="card">
                                    <div class="card-header bg-white">
                                        <h5 class="card-title">E-kortinställningar</h5>
                                    </div>
                                    <div class="card-body">
                                        <ValidationProvider vid="selection" name="Korturval" rules="required" v-slot="{ errors }">
                                            <div class="form-group">
                                                <label class="d-block">Malltyp</label>
                                                <div class="custom-control custom-radio custom-control-inline">
                                                    <input type="radio" class="custom-control-input" name="use_view" id="rdo-use-view" v-model="settings.use_view" :value="1">
                                                    <label class="custom-control-label" for="rdo-use-view">Rednax™ Builder</label>
                                                </div>
                                                <div class="custom-control custom-radio custom-control-inline">
                                                    <input type="radio" class="custom-control-input" name="use_view" id="rdo-use-legacy" v-model="settings.use_view" :value="0">
                                                    <label class="custom-control-label" for="rdo-use-legacy">Legacy</label>
                                                </div>
                                                <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                            </div>
                                        </ValidationProvider>
                                        <input-with-validation
                                            vid="sender_name"
                                            label="Avsändare"
                                            v-model="settings.sender_name"
                                            placeholder="Supékort"
                                            rules="required"
                                        ></input-with-validation>
                                        <input-with-validation
                                            vid="subject"
                                            label="Ämne"
                                            v-model="settings.subject"
                                            rules="required"
                                        ></input-with-validation>
                                    </div>
                                </div>
                                <template #footer>
                                    <div class="d-flex justify-content-end">
                                        <limitless-button ref="btnsavesettings" @click="saveTemplateSettings" :busy="busy_saving" icon="icon-floppy-disk">SPARA</limitless-button>
                                    </div>
                                </template>
                            </template-editor>
                        </div>
                        <div
                            v-else
                            class="card"
                        >
                            <!-- Use old templates -->
                            <div class="card-header bg-white">
                                <h5 class="card-title">E-kortinställningar</h5>
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-lg-6">
                                        <ValidationProvider vid="selection" name="Korturval" rules="required" v-slot="{ errors }">
                                            <div class="form-group">
                                                <label class="d-block">Malltyp</label>
                                                <div class="custom-control custom-radio custom-control-inline">
                                                    <input type="radio" class="custom-control-input" name="use_view" id="rdo-use-view" v-model="settings.use_view" :value="1">
                                                    <label class="custom-control-label" for="rdo-use-view">Rednax™ Builder</label>
                                                </div>
                                                <div class="custom-control custom-radio custom-control-inline">
                                                    <input type="radio" class="custom-control-input" name="use_view" id="rdo-use-legacy" v-model="settings.use_view" :value="0">
                                                    <label class="custom-control-label" for="rdo-use-legacy">Legacy</label>
                                                </div>
                                                <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                            </div>
                                        </ValidationProvider>
                                        <input-with-validation
                                            vid="static_variable"
                                            label="Ämne"
                                            v-model="settings.static_variable"
                                            placeholder="##StaticVariable##"
                                            rules="required"
                                        ></input-with-validation>
                                        <simple-text-editor
                                            cardheader="Texthälsning"
                                            v-model="settings.text"
                                            :toolbar="[
                                                'h1',
                                                'h2',
                                                'h3',
                                                'bold',
                                                'italic',
                                                'strike',
                                                'underline',
                                                'textalign',
                                            ]"
                                        ></simple-text-editor>
                                    </div>
                                    <div class="col-lg-6">
                                        <select-with-validation
                                            vid="ecard_template_id"
                                            label="Epostmall"
                                            component="ecard-template-filter"
                                            v-model="settings.ecard_template_id"
                                            :reduce="(opt) => opt.id"
                                            placeholder="Välj mall..."
                                            rules="required"
                                            :customer-id="settings.customer_id"
                                        ></select-with-validation>
                                        <div class="form-group">
                                            <label>Logo/Bild 1</label>
                                            <div v-if="settings.image_slot_1">
                                                <img v-if="settings.image_slot_1_url" :src="settings.image_slot_1_url" width="100px" class="mb-2" alt="Bild 1">
                                                <div class="input-group">
                                                    <input type="text" class="form-control" :value="settings.image_slot_1" disabled>
                                                    <div class="input-group-append">
                                                        <button type="button" class="btn btn-danger" @click.prevent="removeImage(1)"><i class="icon-trash"></i></button>
                                                    </div>
                                                </div>
                                            </div>
                                            <ValidationProvider v-else vid="image_slot_1_file" name="Logo/Bild 1" rules="" v-slot="{ errors }">
                                                <limitless-file-input @change="(files) => { settings.image_slot_1_file = (files[0] ? files[0] : null); }" ref="fileInput1"></limitless-file-input>
                                                <span class="validation-invalid-label">{{ errors[0] }}</span>
                                            </ValidationProvider>
                                        </div>
                                        <div class="form-group">
                                            <label>Logo/Bild 2</label>
                                            <div v-if="settings.image_slot_2">
                                                <img v-if="settings.image_slot_2_url" :src="settings.image_slot_2_url" width="100px" class="mb-2" alt="Bild 2">
                                                <div class="input-group">
                                                    <input type="text" class="form-control" :value="settings.image_slot_2" disabled>
                                                    <div class="input-group-append">
                                                        <button type="button" class="btn btn-danger" @click.prevent="removeImage(2)"><i class="icon-trash"></i></button>
                                                    </div>
                                                </div>
                                            </div>
                                            <ValidationProvider v-else vid="image_slot_2_file" name="Logo/Bild 2" rules="" v-slot="{ errors }">
                                                <limitless-file-input @change="(files) => { settings.image_slot_2_file = (files[0] ? files[0] : null); }" ref="fileInput2"></limitless-file-input>
                                                <span class="validation-invalid-label">{{ errors[0] }}</span>
                                            </ValidationProvider>
                                        </div>
                                        <div class="custom-control custom-checkbox mb-2" >
                                            <input type="checkbox" class="custom-control-input" id="chk-automatic_sendouts" v-model="settings.embed_images" :true-value="1" :false-value="0">
                                            <label id="embed-images" class="custom-control-label" for="chk-automatic_sendouts">Aktivera inbakning av bilder (CID)</label>
                                        </div>
                                        <b-tooltip target="embed-images" placement="bottomright">
                                            Bifogar bilderna direkt i mailet. OBS! Stänger av tracking!
                                        </b-tooltip>
                                    </div>
                                </div>
                            </div>
                            <div class="card-footer text-right">
                                <limitless-button ref="btnsavesettings" @click="saveTemplateSettings" :busy="busy_saving" icon="icon-floppy-disk">SPARA</limitless-button>
                            </div>
                        </div>
                    </form>
                </ValidationObserver>
            </div>

            <rednax-datatable
                ref="recipientstable"
                :columns="table_columns"
                :filter="table_filter"
                url="/vue/ecard/recipients"
                v-if="settings"
            >
                <template #header>
                    <h5 class="card-title">Mottagare</h5>
                    <div class="header-elements">
                        <button type="button" class="btn btn-light ml-2" @click="$bvModal.show('modal-edit-date')"><i class="icon-alarm mr-1"></i>Schemalägg/Ändra utskicksdatum</button>
                        <button type="button" class="btn btn-light ml-2" @click="$bvModal.show('modal-add-recipients')"><i class="icon-plus3 mr-1"></i>Lägg till mottagare</button>
                    </div>
                </template>
                <template #default>
                    <div class="row">
                        <div class="col-lg-3">
                            <input type="text" class="form-control" v-model="table_filter.search" placeholder="Sök...">
                        </div>
                        <div class="col-lg-3">
                            <vue-select
                                placeholder="Inlösta/Ej inlösta kort"
                                v-model="table_filter.is_redeemed"
                                :options="[
                                    {
                                        id: 1,
                                        label: 'Inlösta kort',
                                    },
                                    {
                                        id: 0,
                                        label: 'Ej inlösta kort',
                                    },
                                ]"
                                :reduce="(opt) => opt.id"
                            ></vue-select>
                        </div>
                        <div class="col-lg-3">
                            <vue-select
                                placeholder="Kortserie"
                                v-model="table_filter.card_series_id"
                                :options="settings.card_series_ids"
                            ></vue-select>
                        </div>
                    </div>
                </template>
                <template #cell_is_sent="{ row }">
                    <i v-if="row.is_sent" :id="'is_sent-' + row.card_uid" class="icon-paperplane text-success"></i>
                    <b-popover key="warning-is_sent" :target="'is_sent-' + row.card_uid" triggers="hover focus" placement="bottom" v-if="row.is_sent">
                        {{ formatDateTime(row.email_last_sent_ts) }}
                    </b-popover>
                </template>
                <template #cell_delivered_ts="{ row }">
                    <i v-if="row.delivered_ts" :id="'delivered_ts-' + row.card_uid" class="icon-mail5 text-success"></i>
                    <b-popover key="warning-delivered_ts" :target="'delivered_ts-' + row.card_uid" triggers="hover focus" placement="bottom" v-if="row.delivered_ts">
                        {{ formatDateTime(row.delivered_ts) }}
                    </b-popover>
                </template>
                <template #cell_opened_ts="{ row }">
                    <i v-if="row.opened_ts" :id="'opened_ts-' + row.card_uid" class="icon-mail-read text-success"></i>
                    <b-popover key="warning-opened_ts" :target="'opened_ts-' + row.card_uid" triggers="hover focus" placement="bottom" v-if="row.opened_ts">
                        {{ formatDateTime(row.opened_ts) }}
                    </b-popover>
                </template>
                <template #cell_clicked_ts="{ row }">
                    <i v-if="row.clicked_ts" :id="'clicked_ts-' + row.card_uid" class="icon-touch text-success"></i>
                    <b-popover key="warning-clicked_ts" :target="'clicked_ts-' + row.card_uid" triggers="hover focus" placement="bottom" v-if="row.clicked_ts">
                        {{ formatDateTime(row.clicked_ts) }}
                    </b-popover>
                </template>
                <template #cell_bounced_ts="{ row }">
                    <i v-if="row.bounced_ts" :id="'bounced_ts-' + row.card_uid" class="icon-reply text-danger"></i>
                    <b-popover key="warning-bounced_ts" :target="'bounced_ts-' + row.card_uid" triggers="hover focus" placement="bottom" v-if="row.bounced_ts">
                        {{ formatDateTime(row.bounced_ts) }}
                    </b-popover>
                </template>
                <template #cell_unsubscribed_ts="{ row }">
                    <i v-if="row.unsubscribed_ts" :id="'unsubscribed_ts-' + row.card_uid" class="icon-stop text-danger"></i>
                    <b-popover key="warning-unsubscribed_ts" :target="'unsubscribed_ts-' + row.card_uid" triggers="hover focus" placement="bottom" v-if="row.unsubscribed_ts">
                        {{ formatDateTime(row.unsubscribed_ts) }}
                    </b-popover>
                </template>
                <template #cell_is_redeemed="{ row }">
                    <i v-if="row.is_redeemed" class="icon-check text-success"></i>
                </template>
                <template #cell_email_scheduled="{ row }">
                    <div v-if="row.email_scheduled" class="badge badge-success">Ja</div>
                    <div v-else class="badge badge-danger">Nej</div>
                </template>
                <template #cell_test_card_mode="{ row }">
                    <limitless-button
                        type="button"
                        :btn-class="(row.test_card_mode ? 'btn-warning' : 'btn-outline-success')"
                        @click="toggleTestmode(row)"
                    >
                        {{ (row.test_card_mode ? 'TEST' : 'LIVE') }}
                    </limitless-button>
                </template>
                <template #cell_buttons="{ row }">
                    <div class="btn-group">
                        <button type="button" class="btn btn-outline-secondary" @click="previewRecipient(row)">
                            <i class="icon-eye mr-2"></i>Visa
                        </button>
                        <button type="button" class="btn btn-outline-secondary" @click="editRecipient(row)">
                            <i class="icon-pen6 mr-2"></i>Ändra
                        </button>
                        <button type="button" class="btn btn-outline-secondary" @click="sendRecipient(row)" style="width: 107px;">
                            <i class="icon-paperplane mr-2"></i>{{ (row.email_sent_ts ? 'Omskick' : 'Skicka') }}
                        </button>
                    </div>
                </template>
            </rednax-datatable>

            <b-modal title="Lägg till mottagare" id="modal-add-recipients" size="xl" ok-only ok-title="Stäng" ok-variant="light">
                <csv-exporter
                    v-if="settings"
                    @csv:exported="$refs.recipientstable.reload()"
                    :card-order-id="id"
                    :card-series-ids="settings.card_series_ids"
                />
            </b-modal>

            <b-modal title="Schemalägg/Ange utskicksdatum" id="modal-edit-date" @ok="massAssignEmailDate">
                <div class="alert alert-info alert-styled-left">Utskicket schemaläggs för alla mottagare som inte redan har löst in sitt kort. Välj "Radera datum" om du istället vill stoppa ett redan schemalagt utskick.</div>
                <ValidationObserver ref="dateform" v-if="settings">
                    <form @submit="massAssignEmailDate">
                        <ValidationProvider vid="scheduled_ts" rules="required" v-slot="{ errors }">
                            <div class="form-group">
                                <label>Utskicksdatum</label>
                                <div class="custom-control custom-radio mb-2">
                                    <input type="radio" class="custom-control-input" name="date-set" id="rdo-date-set" v-model="date.delete_date" :value="false">
                                    <label class="custom-control-label" for="rdo-date-set">Ange nytt datum</label>
                                </div>
                                <div class="custom-control custom-radio mb-2">
                                    <input type="radio" class="custom-control-input" name="date-set" id="rdo-date-delete" v-model="date.delete_date" :value="true">
                                    <label class="custom-control-label" for="rdo-date-delete">Radera datum</label>
                                </div>
                                <div v-if="!date.delete_date">
                                    <v-date-picker
                                        mode="dateTime"
                                        is24hr
                                        v-model="date.scheduled_ts"
                                        :model-config="{ type: 'string', mask: 'iso', timezones: ['Europe/Stockholm'], timezone: 'Europe/Stockholm', locale: 'sv-SE' }"
                                        :min-date="new Date()"
                                    ></v-date-picker>
                                </div>
                                <span class="validation-invalid-label">{{ errors[0] }}</span>
                            </div>
                        </ValidationProvider>

                        <select-with-validation
                            label="Urval (kortserie)"
                            placeholder="Ange för alla mottagare oavsätt kortserie"
                            v-model="date.card_series_id"
                            :options="settings.card_series_ids"
                            rules=""
                        ></select-with-validation>
                    </form>
                </ValidationObserver>
                <template #modal-footer="{ cancel, ok }">
                    <button type="button" class="btn btn-light" @click="cancel">Avbryt</button>
                    <limitless-button ref="btndateform" type="button" @click.prevent="ok" :busy="busy_date">Spara</limitless-button>
                </template>
            </b-modal>

            <b-modal id="modal-recipient-preview" size="lg" ok-only ok-title="Stäng" ok-variant="light">
                <div v-if="preview">
                    <p>
                        Ämne: {{ preview.subject }} <br>
                        Till: {{ preview.to }} <br>
                    </p>
                    <b-card no-body style="padding: 0;">
                        <Iframe
                            frameborder="0"
                            style="width: 100%; height: 70vh; overflow-x: hidden;">
                            <div v-html="preview.html"></div>
                        </Iframe>
                    </b-card>
                </div>
                <div v-else><i class="text-danger">Kan ej förhandsgranska</i></div>
            </b-modal>

            <b-modal id="modal-recipient-edit" size="lg" @ok="saveRecipient">
                <ValidationObserver ref="recipientform" v-if="recipient">
                    <form @submit="saveRecipient">
                        <input-with-validation
                            vid="recipient_email"
                            label="E-post"
                            v-model="recipient.recipient_email"
                            rules="required"
                        ></input-with-validation>
                    </form>
                </ValidationObserver>
                <template #modal-footer="{ cancel, ok }">
                    <limitless-button
                        ref="btndeleterecipient"
                        type="button"
                        btn-class="btn-danger"
                        icon="icon-trash"
                        @click="deleteRecipient"
                        :busy="busy_delete_recipient"
                        class="mr-auto"
                    >
                        Radera
                    </limitless-button>
                    <button
                        type="button"
                        class="btn btn-light"
                        @click="cancel"
                    >
                        Avbryt
                    </button>
                    <limitless-button
                        ref="btnrecipientform"
                        type="button"
                        @click.prevent="ok"
                        :busy="busy_recipient"
                    >
                        Spara
                    </limitless-button>
                </template>
            </b-modal>
        </div>
    </div>
</template>

<script>
import TemplateEditor from '@components/Ecard/TemplateEditor.vue';
import CsvExporter from '@app/pages/cardorder/partials/CsvExporter.vue';
import apiClient from '@services/ApiClient';
import SimpleTextEditor from '@components/SimpleTextEditor.vue';
import VDatePicker from 'v-calendar/lib/components/date-picker.umd';
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader.vue';
import LimitlessButton from '@components/Limitless/LimitlessButton.vue';
import SelectWithValidation from '@components/Form/SelectWithValidation.vue';
import getError from '@services/ErrorHelper';
import InputWithValidation from '@components/Form/InputWithValidation.vue';
import LimitlessFileInput from '@components/Limitless/LimitlessFileInputComponent.vue';
import RednaxDatatable from '@components/Datatable/RednaxDatatableComponent.vue';
import VueSelect from '@components/Wrappers/VueSelect.vue';
import { formatDateTime } from '@services/Helpers';
import Iframe from '@components/Iframe.vue';

export default {
    name: 'CardOrderEcards',
    components: {
        Iframe,
        VueSelect,
        RednaxDatatable,
        LimitlessFileInput,
        InputWithValidation,
        SelectWithValidation,
        LimitlessButton,
        SimpleTextEditor,
        CsvExporter,
        VDatePicker,
        LimitlessPageHeader,
        TemplateEditor,
    },
    props: {
        id: {
            type: [Number, String],
            default: 0,
        },
    },
    data() {
        return {
            busy_loading: false,
            busy_saving: false,
            busy_recipient: false,
            busy_delete_recipient: false,
            busy_date: false,
            settings: null,
            preview: null,
            recipient: null,
            table_filter: {
                search: '',
                card_order_id: null,
                card_series_id: null,
                is_redeemed: null,
            },
            table_columns: [
                {
                    header: 'E-post',
                    data: 'recipient_email',
                    sortable: true,
                },
                {
                    header: 'Kortnummer',
                    data: 'card_uid',
                    sortable: true,
                },
                {
                    header: 'Skickat',
                    data: 'is_sent',
                    sortable: true,
                    class: 'text-center',
                },
                {
                    header: 'Levererad',
                    data: 'delivered_ts',
                    sortable: true,
                    class: 'text-center',
                },
                {
                    header: 'Öppnad',
                    data: 'opened_ts',
                    sortable: true,
                    class: 'text-center',
                },
                {
                    header: 'Klickat',
                    data: 'clicked_ts',
                    sortable: true,
                    class: 'text-center',
                },
                {
                    header: 'Inlöst',
                    data: 'is_redeemed',
                    sortable: true,
                    class: 'text-center',
                },
                {
                    header: 'Bounced',
                    data: 'bounced_ts',
                    sortable: true,
                    class: 'text-center',
                },
                {
                    header: 'Avreg.',
                    data: 'unsubscribed_ts',
                    sortable: true,
                    class: 'text-center',
                },
                {
                    header: 'Köad',
                    data: 'email_scheduled',
                    sortable: true,
                },
                {
                    header: 'Utskicksdatum',
                    data: 'scheduled_ts',
                    sortable: true,
                },
                {
                    header: 'Första utskick',
                    data: 'email_sent_ts',
                    sortable: true,
                    render(row) {
                        return (row.email_sent_ts ? row.email_sent_ts.substring(0, 16) : '');
                    },
                },
                {
                    header: 'Senaste utskick',
                    data: 'email_last_sent_ts',
                    sortable: true,
                    render(row) {
                        return (row.email_last_sent_ts ? row.email_last_sent_ts.substring(0, 16) : '');
                    },
                },
                {
                    header: 'Testläge',
                    data: 'test_card_mode',
                    sortable: true,
                },
                {
                    header: '',
                    data: 'buttons',
                    sortable: false,
                },
            ],
            date: {
                card_series_id: null,
                scheduled_ts: null,
                delete_date: false,
            },
        };
    },
    mounted() {
        this.table_filter.card_order_id = this.id;
        this.getTemplateSettings();
    },
    methods: {
        formatDateTime,
        getTemplateSettings() {
            this.busy_loading = true;
            apiClient.get('/vue/cardorders/' + this.id + '/ecard_settings')
                .then((response) => {
                    this.settings = response.data;
                })
                .finally(() => {
                    this.busy_loading = false;
                });
        },
        async saveTemplateSettings() {
            const isValid = await this.$refs.settingsform.validate();
            if (isValid) {
                let formData = this.settings;
                let config = {};
                if (!this.settings.use_view) {
                    formData = new FormData();
                    config = {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    };
                    Object.keys(this.settings).forEach((key) => formData.append(key, this.settings[key]));
                }
                apiClient.post('/vue/cardorders/' + this.id + '/ecard_settings', formData, config)
                    .then((response) => {
                        this.settings = response.data;
                        this.$refs.btnsavesettings.triggerSaved();
                    })
                    .catch((error) => {
                        const parsederror = getError(error);
                        if (typeof parsederror === 'object') {
                            this.$refs.settingsform.setErrors(parsederror);
                        }
                        this.$refs.btnsavesettings.triggerFailed();
                    })
                    .finally(() => {
                        this.busy_saving = false;
                    });
            } else {
                this.$refs.btnsavesettings.triggerFailed();
            }
        },
        async removeImage(id) {
            let doChange = false;
            await this.$swal({
                text: 'Är du säker att du vill ta bort bilden?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Ja, ta bort!',
                cancelButtonText: 'Avbryt',
            }).then((result) => {
                if (result.isConfirmed) {
                    doChange = true;
                }
            });

            if (doChange) {
                this.$set(this.settings, 'image_slot_' + id, '');
            }
        },
        async massAssignEmailDate(event) {
            event.preventDefault();
            const isValid = await this.$refs.dateform.validate();
            if (isValid) {
                const options = {
                    timeZone: 'Europe/Stockholm',
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                    second: 'numeric',
                };
                const formatter = new Intl.DateTimeFormat('sv-SE', options);
                let formatted = formatter.format(new Date(this.date.scheduled_ts));

                if (this.date.delete_date) {
                    formatted = null;
                }

                apiClient.post('/vue/ecard/recipients/mass-assign', {
                    card_order_id: this.id,
                    card_series_id: this.date.card_series_id,
                    scheduled_ts: formatted,
                }).then(() => {
                    this.$refs.btndateform.triggerSaved();
                    this.$bvModal.hide('modal-edit-date');
                    this.$refs.recipientstable.reload();
                }).catch((error) => {
                    const parsederror = getError(error);
                    if (typeof parsederror === 'object') {
                        this.$refs.dateform.setErrors(parsederror);
                    }
                    this.$refs.btndateform.triggerFailed();
                }).finally(() => {
                    this.busy_saving = false;
                });
            } else {
                this.$refs.btndateform.triggerFailed();
            }
        },
        previewRecipient(recipient) {
            apiClient.post(`/vue/ecard/recipients/${recipient.recipient_id}/preview`).then((res) => {
                this.preview = res.data.data;
                this.$bvModal.show('modal-recipient-preview');
            });
        },
        editRecipient(recipient) {
            this.recipient = { ...recipient };
            this.$bvModal.show('modal-recipient-edit');
        },
        async saveRecipient(event) {
            event.preventDefault();
            if (this.recipient) {
                const isValid = await this.$refs.recipientform.validate();
                if (isValid) {
                    this.busy_recipient = true;
                    apiClient.post(`/vue/ecard/recipients/${this.recipient.recipient_id}`, this.recipient).then(() => {
                        this.$refs.btnrecipientform.triggerSaved();
                        this.$bvModal.hide('modal-recipient-edit');
                        this.$refs.recipientstable.reload();
                    }).catch((error) => {
                        const parsederror = getError(error);
                        if (typeof parsederror === 'object') {
                            this.$refs.recipientform.setErrors(parsederror);
                        }
                        this.$refs.btnrecipientform.triggerFailed();
                    }).finally(() => {
                        this.busy_recipient = false;
                    });
                } else {
                    this.$refs.btnrecipientform.triggerFailed();
                }
            }
        },
        async deleteRecipient() {
            let doDelete = false;
            if (this.recipient) {
                await this.$swal({
                    text: 'Är du säker att du vill radera denna mottagare?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Ja, radera!',
                }).then((result) => {
                    if (result.isConfirmed) {
                        doDelete = true;
                    }
                });
            }
            if (doDelete) {
                this.busy_delete_recipient = true;
                await apiClient.delete(`/vue/ecard/recipients/${this.recipient.recipient_id}`)
                    .then(() => {
                        this.$bvModal.hide('modal-recipient-edit');
                        this.$refs.recipientstable.reload();
                    }).catch(() => {
                        this.$refs.btndeleterecipient.triggerFailed();
                    }).finally(() => {
                        this.busy_delete_recipient = false;
                    });
            }
        },
        sendRecipient(recipient) {
            this.busy_recipient = true;
            apiClient.post(`/vue/ecard/recipients/${recipient.recipient_id}/send`).then(() => {
                this.$swal({
                    title: 'Skickat!',
                    text: 'Mailet har skickats!',
                    icon: 'success',
                    timer: 3000,
                });
                this.$refs.recipientstable.reload();
            }).catch((error) => {
                let message = 'Mailet kunde ej skickas.';
                if (error.response && error.response.data && error.response.data.message) {
                    message = error.response.data.message;
                }
                this.$swal({
                    title: 'Något gick fel...',
                    text: message,
                    icon: 'error',
                    timer: 3000,
                });
            });
        },
        toggleTestmode(recipient) {
            apiClient.post(`/vue/ecard/recipients/${recipient.recipient_id}/set-test-mode`, { test_card_mode: (!recipient.test_card_mode) })
                .then(() => {
                    recipient.test_card_mode = (!recipient.test_card_mode);
                });
        },
    },
};
</script>
